import { ResponseReult } from 'api-base-refrence';
import { filter, map, Observable } from 'rxjs';
import { configsFull } from '../../../domain-layer/entity/configs-options.entity';
import { IConfigsRepository } from '../../../domain-layer/repository/configs.respository';
import { SystemConfigRequest } from '../../api-client/system-config.request';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppNestjsResponse } from 'nestjs-model-utility';

@UntilDestroy()
export class systemConfigRepository implements IConfigsRepository {
  getConfigsValue(): Observable<configsFull> {
    return new SystemConfigRequest.List({ limit: 10 }).call().pipe(
      filter((value) => !!value?.response?.data),
      map((value) => value?.response?.data[0]),
      untilDestroyed(this),
    );
  }
  updateConfigs(
    configs: configsFull,
  ): Observable<ResponseReult<AppNestjsResponse<configsFull>>> {
    return new SystemConfigRequest.Edit()
      .setData(configs)
      .call()
      .pipe(untilDestroyed(this));
  }
}
